<template>
  <div>
    <ModuleHeader>Ticket Promedio por Producto</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="10" cols="12">
                <v-row>
                  <v-col md="4" cols="6">
                    <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="input_date" label="Fecha Inicial" prepend-icon="mdi-calendar" readonly
                          @input="getAperturas()" v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="input_date" @input="
                        menuFechaInicial = false;
                      getAperturas();
                      "></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="4" cols="6">
                    <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="input_date_final" label="Fecha Final" prepend-icon="mdi-calendar"
                          @input="getAperturas()" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="input_date_final" @input="
                        menuFechaInicial2 = false;
                      getAperturas();
                      "></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="4" cols="6">
                    <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                      @input="getAperturas()" :items="departamentos"></v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete v-model="input_familias" label="Familias" :items="familiasList" item-value="id"
                      item-text="Nombre">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete v-model="input_categoria" label="Categoría del producto" :items="categoriesList"
                      multiple item-value="id" item-text="label">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete :items="global_prod" v-model="selectedProducts" multiple item-value="id"
                      item-text="Nombre" label="Productos">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="6" cols="12" class="mt-n6">
                    <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                      :items="turnosList">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="6" cols="12" class="mt-n6">
                    <v-autocomplete label="Meseros" v-model="selectMesero" item-text="Nombre" item-value="id"
                      :items="meserosComp"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="2" cols="12">
                <v-radio-group v-model="orderType">
                  <v-radio :label="`Ordenar mas vendidos`" :value="1"></v-radio>
                  <v-radio :label="`Ordenar por categoria`" :value="2"></v-radio>
                  <v-radio :label="`Ordenar alfabéticamente`" :value="3"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="text-right mt-n5" md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" class="mx-2" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="6" cols="12" class="text-right">
                <v-btn @click="generatePdf()" color="red" dark><v-icon>mdi-file-pdf-box</v-icon>
                  Exportar PDF
                </v-btn>
                <v-btn @click="generatePdfCategoria()" color="red" class="mx-1" dark><v-icon>mdi-file-pdf-box</v-icon>
                  Vendidos por categoria
                </v-btn>
              </v-col>
              <v-col md="2" cols="6" class="text-right">
                <v-btn color="green" dark @click="exportExcel(0)"><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                </v-btn>
              </v-col>
              <v-col md="12" class="mt-n6">
                <v-text-field v-model="filter" label="Filtrar"></v-text-field>
              </v-col>
            </v-row>
            <h3>Productos</h3>
            <v-simple-table class="dense-table" dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Familia</th>
                  <th>Categoria</th>
                  <th>Vendidos</th>
                  <th>Costos</th>
                  <th>Total Costeo</th>
                  <th>Total vendidos</th>
                  <th>Total cuentas</th>
                  <th>Cuentas</th>
                  <th>Total comensales</th>
                  <th>Cuenta promedio</th>
                  <th>Promedio por Comensal</th>
                  <th>Detalle de venta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datos.processedData.length == 0">
                  <td colspan="9">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in dataProductos">
                  <tr :key="index">
                    <td>
                      {{
                        prod.OriginalId === "Reserva"
                          ? "TEE TIMES"
                          : prod.Nombre
                      }}
                    </td>
                    <td>{{ prod.FamiliaName }}</td>
                    <td>{{ prod.CategoriaName }}</td>
                    <td>
                      <b>{{ prod.Vendidos }}</b>
                    </td>
                    <td>
                      <ul>
                        <template v-for="(cost, index) in prod.Costeo">
                          <li :key="index"> {{ cost.depto }}: <b>${{ $pgsHelper.formatNumber(cost.cto.C)
                              }}</b></li>
                        </template>
                      </ul>


                    </td>
                    <td>
                      <ul>
                        <template v-for="(cost, index) in prod.Costeo">
                          <li :key="index"> {{ cost.depto }}: <b>${{ $pgsHelper.formatNumber(cost.cto.C * prod.Vendidos)
                              }}</b></li>
                        </template>
                      </ul>


                    </td>
                    <td>
                      <b>$ {{ $pgsHelper.formatNumber(prod.Total) }}</b>
                    </td>

                    <td>
                      <b>$ {{ $pgsHelper.formatNumber(prod.sumSaleTotals) }}</b>
                    </td>
                    <td>
                      <b>{{ prod.countSales }}</b>
                    </td>
                    <td>{{ prod.totalComensales }}</td>
                    <td>
                      <b>$ {{ $pgsHelper.formatNumber(prod.averageTicket) }}</b>
                    </td>
                    <td>
                      <b>$
                        {{
                          $pgsHelper.formatNumber(prod.averagePerComensal)
                        }}</b>
                    </td>
                    <td>
                      <v-btn small @click="showDetailVenta(prod.OriginalId)" color="success">
                        Ticket Promedio
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="detalleVentaToogle" max-width="800">
      <v-card>
        <v-card-title class="text-h5">
          Detalles de venta
          <v-spacer />
          <v-btn color="green darken-1" dark small @click="exportExcel(1)">
            <v-icon left>mdi-file-excel-box</v-icon>
            Exportar Excel
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- estadísticas leyendo desde groupedDetalleVenta -->
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-sheet class="pa-4 text-center elevation-2">
                <div class="subtitle-2">Total General</div>
                <div class="headline font-weight-bold">
                  $
                  {{ $pgsHelper.formatNumber(groupedDetalleVenta.grandTotal) }}
                </div>
              </v-sheet>
            </v-col>

            <v-col cols="12" sm="4">
              <v-sheet class="pa-4 text-center elevation-2">
                <div class="subtitle-2">Total de tickets</div>
                <div class="headline font-weight-bold">
                  {{ groupedDetalleVenta.tickets }}
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="4">
              <v-sheet class="pa-4 text-center elevation-2">
                <div class="subtitle-2">Total de comensales</div>
                <div class="headline font-weight-bold">
                  {{ groupedDetalleVenta.comensales }}
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6">
              <v-sheet class="pa-4 text-center elevation-2">
                <div class="subtitle-2">Promedio por ticket</div>
                <div class="headline font-weight-bold">
                  $
                  {{
                    $pgsHelper.formatNumber(groupedDetalleVenta.averageTicket)
                  }}
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6">
              <v-sheet class="pa-4 text-center elevation-2">
                <div class="subtitle-2">Promedio por comensal</div>
                <div class="headline font-weight-bold">
                  $
                  {{
                    $pgsHelper.formatNumber(
                      groupedDetalleVenta.averagePerComensal
                    )
                  }}
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <div v-if="
            !groupedDetalleVenta.groups || !groupedDetalleVenta.groups.length
          ">
            <v-alert type="info" border="left" colored-border>
              No se encontraron datos
            </v-alert>
          </div>

          <!-- panels basados en groupedDetalleVenta.groups -->
          <v-expansion-panels focusable inset class="mt-4">
            <v-expansion-panel v-for="group in groupedDetalleVenta.groups" :key="group.folio">
              <v-expansion-panel-header>
                <div>
                  <strong>
                    <span class="selectable"> Folio {{ group.folio }} </span>
                  </strong>
                  — Total: ${{ $pgsHelper.formatNumber(group.total) }} —
                  Comensales: {{ group.comensales }}
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-card flat class="text-center">
                  Fecha: {{ group.fecha }} &mdash; Cliente: {{ group.cliente }}
                </v-card>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th class="text-right">Cantidad</th>
                      <th>Nombre</th>
                      <th class="text-right">Precio U.</th>
                      <th class="text-right">Total</th>
                      <th>Moneda</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(prod, idx) in group.items" :key="idx"
                      :class="prod.isPrincipal ? 'light-blue lighten-5' : ''">
                      <td class="text-right">{{ prod.Cantidad }}</td>
                      <td>
                        {{ prod.Nombre }}
                        <ul v-if="prod.Descuentos.length">
                          <li v-for="(Desc, idx) in prod.Descuentos" :key="idx">
                            {{ Desc.Cnt }} - {{ Desc.Dsc }} {{ Desc.Ttl.C
                            }}{{ Desc.Ttl.M }}
                          </li>
                        </ul>
                      </td>
                      <td class="text-right">
                        <strong>{{
                          $pgsHelper.formatNumber(prod.PrecioUnitario)
                        }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{
                          $pgsHelper.formatNumber(prod.Precio)
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{ prod.Moneda }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="detalleVentaToogle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import TarifasClass from "../../clases/Tarifa.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import TicketPromedioProducto from "../../clases/PdfMakers/TicketPromedioProducto.js";
import TicketPromedioProductoCate from "../../clases/PdfMakers/TicketPromedioProductoCate.js";
import { mapGetters, mapActions } from "vuex";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import DetalleTicketPromedioExcel from "../../clases/ExcelMaker/TicketPromedioProductoExcel.js";
export default {
  name: "reporte_tpromprod",
  components: {},
  props: [],
  data() {
    return {
      costos: {},
      selectedProducts: [],
      selectMesero: "ALL",
      meseros: [],
      selectTurno: "ALL",
      selectDep: "ALL",
      Horarios: [],
      orderType: 1,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      input_familias: "ALL",
      loadingData: false,
      filter: "",
      datos: {
        all: [],
        processedData: [],
      },
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      tiposJuego: [],
      input_categoria: ["ALL"],
      tarifarios: [],
      data_cajas: [],
      cashiers: [],
      Categories: [],
      familias: [],
      aperturas: [],

      detalleVentaToogle: false,
      groupedDetalleVenta: [],
      grandTotal: 0,
      averageTicket: 0,
      averagePerComensal: 0,
    };
  },
  computed: {
    ...mapGetters(["getProductos"]),
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    global_prod() {
      let productos = [];
      this.getProductos.forEach((element) => {
        if (
          element.Tipo != "AYB-Insumo" &&
          element.Tipo != "AYB-ICompuesto" &&
          !element.Dlat
        ) {
          productos.push(element);
        }
      });
      return productos;
    },
    dataProductos() {
      if (this.filter != "") {
        return this.datos.processedData.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      return this.datos.processedData;
    },
    meserosComp() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.meseros;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    categoriesList() {
      let categories = [{ id: "ALL", label: "TODOS" }];

      this.Categories.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    familiasList() {
      let categories = [
        { id: "ALL", Nombre: "TODOS" },
        {
          id: "TRANSPORTACION",
          Nombre: "TRANSPORTACION (Sistema)",
        },
        {
          id: "EXTRA RIDER",
          Nombre: "EXTRA RIDER (Sistema) ",
        },
        {
          id: "Paquetes Rondas de Golf",
          Nombre: "Paquetes Rondas de Golf (Sistema)",
        },
      ];

      this.familias.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    /* Métodos para la vista */
    searchVentas() {
      Promise.resolve()
        .then(() => {
          this.loadingData = true;
        })
        .then(() => {
          return this.getVentas();
        })
        .then(() => {
          this.loadingData = false;
        })
        .then(() => {
          return this.$nextTick();
        })
        .then(() => {
          this.processVentas();
        });
    },

    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.selectDep = "ALL";
    },

    showDetailVenta(originalId) {
      this.detalleVentaToogle = true;

      // inicializar groupedDetalleVenta con grupos vacíos y valores por defecto
      this.groupedDetalleVenta = {
        groups: [],
        grandTotal: 0,
        averageTicket: 0,
        averagePerComensal: 0,
        comensales: 0,
        tickets: 0,
      };

      // asignar promedios desde processedData
      const proc =
        this.datos.processedData.find((p) => p.OriginalId === originalId) || {};
      this.groupedDetalleVenta.averageTicket = proc.averageTicket || 0;
      this.groupedDetalleVenta.averagePerComensal =
        proc.averagePerComensal || 0;

      // rellenar .groups con cada ticket que incluya el producto principal
      this.datos.all.forEach((ticket) => {
        if (!ticket.Catalogo.some((prod) => prod.Id === originalId)) return;

        const folio = ticket.Folio;
        const fecha = ticket.fecha || ticket.FechaVenta;
        const cliente = ticket.Cliente?.Nombre || "";
        const comensales = ticket.Comensales || ticket.numComensales || 1;

        // buscar grupo existente por folio o crearlo si no existe
        let grp = this.groupedDetalleVenta.groups.find(
          (g) => g.folio === folio
        );
        if (!grp) {
          grp = { folio, fecha, cliente, comensales, items: [], total: 0 };
          this.groupedDetalleVenta.groups.push(grp);
        }

        // agregar cada producto al grupo y acumular su precio
        ticket.Catalogo.forEach((prod) => {
          const cantidad = prod.Cnt - (prod.Dto || 0);
          let Descuentos = [];
          let precio = 0;
          if (prod.Pagos) {
            Object.values(prod.Pagos).forEach((pago) => (precio += pago.def.C));
          }
          if (prod.Descuentos) {
            Descuentos = prod.Descuentos;
          }
          const isPrincipal = prod.Id === originalId;

          grp.items.push({
            Cantidad: Number(cantidad),
            Nombre: prod.Nombre,
            PrecioUnitario: prod.Precio,
            Descuentos: Descuentos,
            Precio: Number(precio),
            Moneda: prod.Moneda,
            isPrincipal,
          });
          grp.total += precio;
        });
      });

      // calcular total de todos los grupos
      this.groupedDetalleVenta.grandTotal =
        this.groupedDetalleVenta.groups.reduce((sum, g) => sum + g.total, 0);
      // calcular total de comensales
      this.groupedDetalleVenta.comensales =
        this.groupedDetalleVenta.groups.reduce(
          (sum, g) => sum + g.comensales,
          0
        );
      this.groupedDetalleVenta.tickets = this.groupedDetalleVenta.groups.length;
    },
    /* Cálculos */

    // Calcula el total de la venta
    calcularSaleTotal(ticket) {
      return ticket.Catalogo.reduce((sum, prod) => {
        if (!prod.Pagos) return sum;
        return sum + Object.values(prod.Pagos).reduce((s, p) => s + p.def.C, 0);
      }, 0);
    },

    // Precio total y conteo de pagos de un producto
    obtenerDatosPagos(prod) {
      return Object.values(prod.Pagos || {}).reduce(
        (acc, p) => {
          acc.precioTotal += p.def.C;
          acc.cntPagos += p.cnt;
          return acc;
        },
        { precioTotal: 0, cntPagos: 0 }
      );
    },

    // Reglas “especiales” (Reserva -> Green Fee, ExtraRidder, Transportación, Cupon)
    aplicarReglasEspeciales(item) {
      // GREEN FEE (Reserva)
      if (item.Id.includes("Reserva")) {
        item.Nombre = "GREEN FEE";
        item.Categoria.N = "GREEN FEE";
        if (item.Orn !== "Golf") {
          item.Familia.N = item.Orn;
          item.Familia.I = item.Orn;
          item.Categoria.N = item.Orn;
        }

        const subProd = item.Catalogo?.[0];
        const tarifaData = subProd?.ExtraParams?.TarifaData;

        if (subProd?.Tip === "Serie") {
          item.Nombre += " PREPAGADO " + subProd.Nombre;
        }

        let subTarifa = "";
        if (tarifaData) {
          const { Tar, Mod, Hor, SubN, Tur } = tarifaData;
          const tipoJuego = this._tiposJuegoMap.get(Mod);
          const horario = this._horariosMap.get(Hor);
          const tarifa = this._tarifariosMap.get(Tar);

          if (Tur) item.Tur = Tur;
          if (tarifa) item.Nombre += " " + tarifa.text;
          if (SubN) {
            subTarifa = SubN;
            item.Nombre += " " + SubN;
          }
          if (horario) item.Nombre += " " + horario.NombreCompleto;
          if (tipoJuego) item.Nombre += " " + tipoJuego.nombre;

          item.Id += `-${item.Categoria.I}-${Tar}${subTarifa}`;
        }
      }

      // EXTRA RIDER
      if (item.Id.includes("RVA-ExtraRidder")) {
        item.Nombre = "Extra rider";
        item.Categoria = item.Familia = { I: "EXTRA RIDER", N: "EXTRA RIDER" };
      }

      // TRANSPORTACIÓN
      if (item.Id.includes("RVA-Transportacion")) {
        item.Nombre = "Transportacion";
        item.Categoria = item.Familia = {
          I: "TRANSPORTACION",
          N: "TRANSPORTACION",
        };
      }

      // CUPÓN
      if (item.Tip === "Cupon") {
        item.Categoria = item.Familia = {
          I: "Paquetes Rondas de Golf",
          N: "Paquetes Rondas de Golf",
        };
      }
    },

    // Procesa un producto: clona, filtra, calcula y aplica reglas
    procesarProducto(prod, saleTotal, comensales) {
      const { precioTotal, cntPagos } = this.obtenerDatosPagos(prod);
      const cantidad = prod.Cnt - (prod.Dto || 0);
      const indetPrice = cantidad > 0 ? precioTotal / cantidad : 0;

      // filtro por mesero
      if (
        this.selectMesero !== "ALL" &&
        prod.ExtraParams?.AYB?.Mesero !== this.selectMesero
      )
        return null;
      if (cantidad <= 0) return null;

      // clonamos para no mutar original
      const item = {
        ...prod,
        OriginalId: prod.Id,
        Costeo: this.costos[prod.Id],
        Precio: indetPrice,
        Vendidos: cantidad,
        Total: precioTotal,
        Diff: cantidad - cntPagos,
        sumSaleTotals: saleTotal,
        totalComensales: comensales,
        countSales: 1,
        Tickets: [],
        grouperDate: {},
      };

      this.aplicarReglasEspeciales(item);
      return item;
    },

    // Agrega o acumula el item al map de productos
    agregarAGrupador(productosSum, item, ticket) {
      const key = item.OriginalId;
      const fecha = ticket.FechaVenta;

      if (!productosSum[key]) {
        productosSum[key] = {
          ...item,
          Categoria: item.Categoria.I,
          CategoriaName: item.Categoria.N,
          Familia: item.Familia.I,
          FamiliaName: item.Familia.N,
          Tickets: [ticket.Folio],
          grouperDate: { [fecha]: { Cantidad: item.Vendidos } },
        };
      } else {
        const grp = productosSum[key];

        grp.Vendidos += item.Vendidos;
        grp.Total += item.Total;
        grp.Diff += item.Diff;

        if (grp.grouperDate[fecha]) {
          grp.grouperDate[fecha].Cantidad += item.Vendidos;
        } else {
          grp.grouperDate[fecha] = { Cantidad: item.Vendidos };
        }

        // sumamos por folio
        if (!grp.Tickets.includes(ticket.Folio)) {
          grp.Tickets.push(ticket.Folio);
          grp.countSales += 1;
          grp.sumSaleTotals += item.sumSaleTotals;
          grp.totalComensales += item.totalComensales;
        }
      }

      // recalcular precio unitario
      productosSum[key].Precio = productosSum[key].Vendidos
        ? productosSum[key].Total / productosSum[key].Vendidos
        : 0;
    },

    // Filtra por categoría/familia, aplica productos seleccionados y ordena
    filtrarYOrdenar(arrayData) {
      const matchesCat = (it) =>
        this.input_categoria.includes("ALL") ||
        this.input_categoria.includes(it.Categoria) ||
        (this.input_categoria.includes("GREENFEE") &&
          it.Id.includes("Reserva"));

      const matchesFam = (it) =>
        this.input_familias === "ALL" || it.Familia === this.input_familias;

      let result = arrayData.filter((it) => matchesCat(it) && matchesFam(it));

      if (this.selectedProducts.length) {
        result = result.filter((it) =>
          this.selectedProducts.includes(it.OriginalId)
        );
      }

      const estrategias = {
        1: { keys: ["Vendidos"], orders: ["desc"] },
        2: { keys: ["Categoria", "Vendidos"], orders: ["desc", "desc"] },
        3: { keys: ["Nombre", "Vendidos"], orders: ["asc", "desc"] },
      };
      const { keys, orders } = estrategias[this.orderType] || estrategias[1];

      return this.$_.orderBy(result, keys, orders);
    },

    processVentas() {
      console.time("ProcessVentas");
      // Pre-indexar lookups para O(1) en aplicarReglasEspeciales
      this._tiposJuegoMap = this.$pgsHelper.createIndex(this.tiposJuego, 'id');
      this._horariosMap = this.$pgsHelper.createIndex(this.Horarios, 'id');
      this._tarifariosMap = this.$pgsHelper.createIndex(this.tarifarios, 'Id');
      const productosSum = {};

      this.datos.all.forEach((ticket) => {
        const saleTotal = this.calcularSaleTotal(ticket);
        const comensales = ticket.Comensales || ticket.numComensales || 1;

        ticket.Catalogo.forEach((prod) => {
          const item = this.procesarProducto(prod, saleTotal, comensales);
          if (item) this.agregarAGrupador(productosSum, item, ticket);
        });
      });

      let arrayData = Object.values(productosSum);
      arrayData = this.filtrarYOrdenar(arrayData);

      arrayData.forEach((item) => {
        // Promedio por ticket: total del producto / número de tickets
        item.averageTicket = item.countSales
          ? item.sumSaleTotals / item.countSales
          : 0;

        // Promedio por comensal: total del producto / total de comensales
        item.averagePerComensal = item.totalComensales
          ? item.sumSaleTotals / item.totalComensales
          : 0;
      });

      this.datos.processedData = arrayData;
      console.timeEnd("ProcessVentas");
    },

    /* Exports*/

    exportExcel(type) {
      if (type == 0) {

        const formattedData = this.datos.processedData.map((item) => {
          let costeoText = ""
          let costeoTotales = ""
          if (this.selectDep != "ALL") {
            const costo = this.$pgsHelper.getById(item.Costeo, "depto", this.selectDep)
            if (costo) {
              costeoText = Number(this.$pgsHelper.roundDecimals(costo.cto.C))
              costeoTotales = Number(this.$pgsHelper.roundDecimals(costo.cto.C * Number(item.Vendidos)))
            }
          } else {
            if (item.Costeo) {
              item.Costeo.forEach((costo) => {
                costeoText += costo.depto + " : $" + this.$pgsHelper.formatNumber(costo.cto.C) + " "
                costeoTotales += costo.depto + " : $" + this.$pgsHelper.formatNumber(costo.cto.C * Number(item.Vendidos)) + " "
              })
            }
          }

          return {
            Nombre: item.OriginalId === "Reserva" ? "TEE TIMES" : item.Nombre,
            Familia: item.FamiliaName,
            Categoria: item.CategoriaName,
            Vendidos: this.$pgsHelper.formatNumber(Number(item.Vendidos)),
            Costeo: costeoText,
            CosteoTotales: costeoTotales,
            "Total por producto": this.$pgsHelper.formatNumber(
              Number(item.Total)
            ),
            "Total ventas": this.$pgsHelper.formatNumber(
              Number(item.sumSaleTotals)
            ),
            Cuentas: this.$pgsHelper.formatNumber(Number(item.countSales)),
            "Total comensales": this.$pgsHelper.formatNumber(
              Number(item.totalComensales)
            ),
            "Promedio Ticket": this.$pgsHelper.formatNumber(
              Number(item.averageTicket)
            ),
            "Promedio por Comensal": this.$pgsHelper.formatNumber(
              Number(item.averagePerComensal)
            ),
          }

        });
        const options = {
          json_fields: {
            Nombre: "Nombre",
            Familia: "Familia",
            Categoria: "Categoria",
            Vendidos: "Vendidos",
            Costos: "Costeo",
            "Total Costeo": "CosteoTotales",
            "Total Vendidos": "Total por producto",
            "Total cuentas": "Total ventas",
            Cuentas: "Cuentas",
            "Total comensales": "Total comensales",
            "Cuenta Promedio": "Promedio Ticket",
            "Promedio por Comensal": "Promedio por Comensal",
          },
        };

        GenericExcelExporter.generateExcelBuffer(formattedData, options)
          .then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Venta producto.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((err) => console.error("Error exportando Excel:", err));
      } else {
        // Generamos el Excel con los datos transformados
        DetalleTicketPromedioExcel.generateExcelBuffer(this.groupedDetalleVenta)
          .then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Detalle de venta producto.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((err) => console.error("Error exportando Excel:", err));
      }
    },
    generatePdf() {
      const mainData = {
        // TITLE: "Ticket Promedio por Producto",
        FI: this.input_date,
        FF: this.input_date_final,
        FG: moment().format("DD/MM/YYYY"),
        HG: moment().format("HH:mm:ss"),
        data: this.dataProductos,
      };

      const docDefinition = TicketPromedioProducto.getDocData(mainData);
      pdfmake.createPdf(docDefinition).open();
    },

    generatePdfCategoria() {
      let mainData = {
        // TITLE: "Ticket Promedio por Categoria",
        FI: this.input_date,
        FF: this.input_date_final,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.dataProductos,
      };
      let docData = TicketPromedioProductoCate.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },

    /* GETS */
    async getAperturas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = moment(endDate, "YYYY-MM-DD")
        .add(1, "day")
        .format("YYYY-MM-DD");
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      const cajasMap = this.$pgsHelper.createIndex(this.data_cajas, 'id');
      const cashiersMap = this.$pgsHelper.createIndex(this.cashiers, 'Id');
      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = cajasMap.get(apt.Caja) || {};
        let cajeroData = cashiersMap.get(apt.Cajero) || {};
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    async getHorarios() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/Golf/Horarios"
        );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({
          id: element[0],
          NombreCompleto: element[1].Nombre,
          ...element[1],
        });
      });
    },
    async getVentas() {
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }

      let listVentas = [];

      let taskTurnos = turnos.map(async (id) => {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        if (this.selectDep != "ALL") {
          filter.push(firestore.where("Departamento", "==", this.selectDep));
        }

        filter.push(firestore.where("Turno", "==", id));

        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
      });
      await Promise.all(taskTurnos).then((turnos) => {
        listVentas.forEach((item) => {
          item.fecha = new moment(item.FechaCreacion).format(
            "YYYY-MM-DD HH:mm"
          );
        });

        listVentas = this.$_.orderBy(listVentas, "fecha", "desc");

        this.datos.all = listVentas;
      });
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getTiposJuego() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/Golf/Modalidades"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      const cats = this.getCategoriesFiltered(claims);
      this.Categories = [{ id: "GREENFEE", label: "GREEN FEE" }, ...cats];
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where(
          "Dlat",
          "==",
          null
        ),
      ]);
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let globalCosto = {};
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
  },
  beforeMount: function () {
    this.getCostos();
    this.getCajas();
    this.getCashiers();
    this.getAperturas();
    this.getMeserosAB();
    this.getCategories();
    this.getFamilias();
    this.getTiposJuego();
    this.getHorarios();
    this.getComboTarifarios();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}

.selectable {
  user-select: text;
}
</style>
